import React from "react";
import { TextField, FormLayout, Select, Button, Text } from "@shopify/polaris";
import ReCAPTCHA from "components/ReCAPTCHA";
import emailIMG from "img/icons/entities/email.svg";
import personIMG from "img/icons/entities/person.svg";
import suitcaseIMG from "img/icons/entities/suitcase.svg";
import config from "config";
import SingUpButtons from './SingUpButtons';
import BannerCustom from "components/Banners/BannerCustom";

const SignUpStep1 = ({
  t,
  countries,
  email,
  errorEmail,
  name,
  errorName,
  surname,
  errorSurname,
  companyName,
  errorCompanyName,
  country,
  errorCountry,
  referral_token,
  registering,
  onChange,
  onChangeCountry,
  onValidateEmail,
  onNext,
  inviteErrorMessage,
  signupError,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    {/*<SingUpButtons countries={countries}/>*/}
    <form style={{ width: '100%' }}>
      {(inviteErrorMessage || signupError) && (
        <div style={{ marginBottom: 20, width: '100%' }}>
          <BannerCustom
            status="error"
            message={signupError || inviteErrorMessage}
          />
        </div>
      )}
      <div style={{ marginBottom: 20}}>
        <Text as={'h2'} alignment="center" variant="headingMd"  >
          Register with your Email Address
        </Text>
      </div>
      <FormLayout>
        <FormLayout.Group condensed>
          <TextField
              id='name'
              type='text'
              prefix={<img src={personIMG} alt='name' style={{ marginTop: 6 }} />}
              label={t("signUp.name")}
              placeholder={t("signUp.name")}
              value={name}
              error={errorName}
              onChange={(value, id) => onChange(value, id, 'errorName', t("signUp.enterName"))}
              requiredIndicator
          />
          <TextField
              id='surname'
              type='text'
              prefix={<img src={personIMG} alt='surname' style={{ marginTop: 6 }} />}
              label={t("signUp.surname")}
              placeholder={t("signUp.surname")}
              value={surname}
              error={errorSurname}
              onChange={(value, id) => onChange(value, id, 'errorSurname', t("signUp.enterSurname"))}
              requiredIndicator
          />
        </FormLayout.Group>

        <TextField
          name='email'
          type='email'
          prefix={<img src={emailIMG} alt='email' style={{ marginTop: 6 }} />}
          label={t("signUp.email")}
          placeholder={t("signUp.email")}
          autoComplete='email'
          value={email}
          error={errorEmail}
          onBlur={onValidateEmail}
          onChange={(value) => onChange(value, 'email', 'errorEmail', t("signUp.invalidEmail"))}
            requiredIndicator
        />
        {/*<Select*/}
        {/*  label={<Text color='subdued' variant='bodySm'>{t("signUp.country")}</Text>}*/}
        {/*  placeholder={t("signUp.country")}*/}
        {/*  error={errorCountry}*/}
        {/*  options={[*/}
        {/*    { label: "", value: "" },*/}
        {/*    ...countries.map((country) => ({*/}
        {/*      label: country.name_no_article,*/}
        {/*      value: country.code,*/}
        {/*    })),*/}
        {/*  ]}*/}
        {/*  onChange={onChangeCountry}*/}
        {/*  value={country}*/}
        {/*/>*/}

        <TextField
          id='companyName'
          type='text'
          prefix={<img src={suitcaseIMG} alt='company name' style={{ marginTop: 6 }} />}
          label={t("signUp.companyName")}
          placeholder={t("signUp.companyName")}
          value={companyName}
          error={errorCompanyName}
          onChange={(value, id) => onChange(value, id, 'errorCompanyName', t("signUp.enterCompany"))}
        />
        <input type='hidden' name='referral_token' value={referral_token} />

        <Button
          disabled={registering || !!inviteErrorMessage}
          loading={registering}
          variant='primary'
          onClick={onNext}
        >
          Next
        </Button>
      </FormLayout>
    </form>
  </div>
);

export default SignUpStep1;
